/* eslint-disable  */
import Image from 'next/image';

// import branchesIcon from "@/assets/images/icons/branches-icon.svg";
// import customerIcon from "@/assets/images/icons/customer-icon.svg";
// import legacyIcon from "@/assets/images/icons/legacy-icon.svg";
import branchesIcon from '@/assets/images/icons/BranchesFinal.svg';
import legacyIcon from '@/assets/images/icons/LegacyFinal.svg';
import customerIcon from '@/assets/images/icons/TrustFinal.svg';

export const HomeWhy = (props: any) => {
  const { desc, bannerImageSrc, bannerImageAlt } = props;
  return (
    <section className="bg bg--white home__why pb-0 font-helvetica-neue">
      <div className="container">
        <div className="bg-whyOne">
          <div className="why-one-parent-container">
            <div className="why-one-flex-prop why-one-text-container">
              <h2 className="text--black text--bold  heading-Onem">
                Why Muthoot FinCorp ONE
              </h2>
              <p className="text--black text--regular para-why-one">
                {/* Muthoot FinCorp ONE comes with the Muthoot Pappachan Group's
                (Muthoot Blue) trademark trust and customer service, powered by
                our team of dedicated finance experts always willing to serve
                you. */}
                Muthoot FinCorp ONE, as an SBU of Muthoot FinCorp Limited, is a
                one-stop solution to cover all your finances. With a legacy
                spanning over 135 years and the trust of more than 1 crore
                customers driving us, you can be confident that when you are
                with us, you are with the best in the business.
              </p>
            </div>
            <div className="why-one-cards-cotainer">
              <div className="why-one-flex-prop why-one-card why-one-card-bg1">
                <Image
                  style={{ color: undefined }}
                  src={legacyIcon}
                  alt="legacy"
                />
                <p className="text--regular why-one-card-text">
                  <span className="text--bold">135 years+</span> <br /> of
                  legacy
                </p>
              </div>
              <div className="why-one-flex-prop why-one-card why-one-card-bg2">
                <Image
                  style={{ color: undefined }}
                  src={customerIcon}
                  alt="legacy"
                />
                <p className="text--regular why-one-card-text">
                  Trust of over <span className="text--bold"></span> 1 Cr.{' '}
                  <br />
                  customers
                </p>
              </div>
              <div className="why-one-flex-prop why-one-card why-one-card-bg3">
                <Image
                  style={{ color: undefined }}
                  src={branchesIcon}
                  alt="legacy"
                />
                <p className="text--regular why-one-card-text">
                  <span className="text--bold">3700+ branches</span> <br />
                  across India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row align-items-start">
          <div className="col-lg-7 order-lg-2 order-1">
            <div className="row">
              <div className="col-6 why__card-col">
                <div className="why__card">
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={card1}
                    alt="legacy icon"
                  />
                </div>
              </div>
              <div className="col-6 why__card-col">
                <div className="why__card">
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={card2}
                    alt="Unparalleled icon"
                  />
                </div>
              </div>
              <div className="col-6 why__card-col">
                <div className="why__card">
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={card3}
                    alt="Branches icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};
